import { render, staticRenderFns } from "./DiscussionRepliesList.vue?vue&type=template&id=344fccc8&scoped=true&"
import script from "./DiscussionRepliesList.vue?vue&type=script&lang=js&"
export * from "./DiscussionRepliesList.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionRepliesList.vue?vue&type=style&index=0&id=344fccc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344fccc8",
  null
  
)

export default component.exports